import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Copy, Ellipsis, Pencil, Trash2 } from "lucide-react";

import ACL_RELATIONSHIPS from "acl-relationships";
import { buttonVariants } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import Authorized from "components/Authorized";
import DeleteEmailExemptionModal from "routes/email/components/DeleteEmailExemptionModal";

const EDIT_ACLS = [
  ACL_RELATIONSHIPS.emailExemption.create,
  ACL_RELATIONSHIPS.emailExemption.edit,
  ACL_RELATIONSHIPS.emailExemption.read,
];
const DELETE_ACLS = [
  ACL_RELATIONSHIPS.emailExemption.read,
  ACL_RELATIONSHIPS.emailExemption.delete,
];
const CLONE_ACLS = [
  ACL_RELATIONSHIPS.emailExemption.read,
  ACL_RELATIONSHIPS.emailExemption.create,
];
const ANY_ACLS = [...EDIT_ACLS, ...DELETE_ACLS, ...CLONE_ACLS];

export function EmailExemptionsTableActions({ original }) {
  const navigate = useNavigate();
  const [deleteOpen, setDeleteOpen] = useState(false);

  return (
    <Authorized permissions={ANY_ACLS} partialMatch>
      <>
        <DropdownMenu>
          <DropdownMenuTrigger
            aria-label="Email exemption actions"
            className={buttonVariants({ variant: "ghost", size: "icon-sm" })}
          >
            <Ellipsis />
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="tw:w-auto">
            <Authorized permissions={EDIT_ACLS}>
              <DropdownMenuItem
                onClick={() =>
                  navigate(`/settings/email_exemptions/${original.id}`)
                }
              >
                <Pencil />
                Edit
              </DropdownMenuItem>
            </Authorized>
            <Authorized permissions={CLONE_ACLS}>
              <DropdownMenuItem
                onClick={() =>
                  navigate(
                    `/settings/email_exemptions/new?clone=${original.id}`
                  )
                }
              >
                <Copy />
                Clone
              </DropdownMenuItem>
            </Authorized>
            <Authorized permissions={DELETE_ACLS}>
              <DropdownMenuItem
                variant="destructive"
                onClick={() => setDeleteOpen(true)}
              >
                <Trash2 />
                Delete
              </DropdownMenuItem>
            </Authorized>
          </DropdownMenuContent>
        </DropdownMenu>
        <Authorized permissions={DELETE_ACLS}>
          <DeleteEmailExemptionModal
            exemptionId={original.id}
            open={deleteOpen}
            onOpenChange={setDeleteOpen}
          />
        </Authorized>
      </>
    </Authorized>
  );
}
